export function convertEnumToString(string: string | any | undefined): string {
  if (!string) return "";
  string = string.toLowerCase();
  return string
    .split("_")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
